export default class CiiCalculationInputData {
    constructor(
        averageLadenSpeed,
        averageBallastSpeed,
        averageLadenFocPerDay,
        averageBallastFocPerDay,
        averageExcessFocDueToWeatherPerDay,
        averageFouling,
        ladenTimePercentage,
        ballastTimePercentage,
        idleTimePercentage,
        auxCO2Contribution,
    ) {
        this.date = new Date().toISOString().substring(0, 10);
        this.averageLadenSpeed = averageLadenSpeed;
        this.averageBallastSpeed = averageBallastSpeed;
        this.averageLadenFocPerDay = averageLadenFocPerDay;
        this.averageBallastFocPerDay = averageBallastFocPerDay;
        this.averageExcessFocDueToWeatherPerDay = averageExcessFocDueToWeatherPerDay;
        this.averageFouling = averageFouling;
        this.ladenTimePercentage = ladenTimePercentage;
        this.ballastTimePercentage = ballastTimePercentage;
        this.idleTimePercentage = idleTimePercentage;
        this.auxCO2Contribution = auxCO2Contribution;
    }

    toInputList() {
        return [
            this.date,
            this.averageLadenSpeed.input,
            this.averageBallastSpeed.input,
            this.averageLadenFocPerDay.input,
            this.averageBallastFocPerDay.input,
            this.averageExcessFocDueToWeatherPerDay.input,
            this.averageFouling.input,
            this.ladenTimePercentage.input,
            this.ballastTimePercentage.input,
            this.idleTimePercentage.input,
            this.auxCO2Contribution.input,
        ]
    }
}
